__turbopack_context__.v({
  "switcher": "languageSwitcher-module-scss-module__TVbNIG__switcher",
  "switcherContainer": "languageSwitcher-module-scss-module__TVbNIG__switcherContainer",
  "switcherControl": "languageSwitcher-module-scss-module__TVbNIG__switcherControl",
  "switcherMenu": "languageSwitcher-module-scss-module__TVbNIG__switcherMenu",
  "switcherMenuList": "languageSwitcher-module-scss-module__TVbNIG__switcherMenuList",
  "switcherOption": "languageSwitcher-module-scss-module__TVbNIG__switcherOption",
  "switcherSingleValue": "languageSwitcher-module-scss-module__TVbNIG__switcherSingleValue",
  "switcherValueContainer": "languageSwitcher-module-scss-module__TVbNIG__switcherValueContainer",
});
